// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120611/js/" + chunkId + "." + {"44":"e57251d3","225":"66a49d31","481":"7b584dba","486":"c8fdd824","770":"d4f681ce"}[chunkId] + ".0.3495816746584578.chunk.js";
};